// extracted by mini-css-extract-plugin
export default {"others":"Footer_others__1Ekva","quickLinks":"Footer_quickLinks__PV-Kq","socialIcon":"Footer_socialIcon__XwaXj"};